import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import useTranslation from 'next-translate/useTranslation'
import { useRouter } from 'next/router'
import Link from 'next/link'
import { GroupsList, SubGroupsList, GroupsListWithNewParts } from 'SRC/modules/groups/components'
import { GroupHorizontalMenuMobile } from 'SRC/modules/categories/components'
import { CategoriesFilter } from 'SRC/modules/ads/filter/components'
import { FilterButtons } from 'SRC/modules/layout/Header/components/FilterButtons'
import { FilterButtons as FilterButtonsVehicleParts } from 'SRC/modules/vehicleParts/list/components'
import { getCurrentGroup } from 'SRC/modules/groups/selectors'
import { getCurrentSubCategory } from 'SRC/modules/categories/selectors'
import config from 'SRC/config/config.json'
import translations from '../../../../../public/data/translations.json'

const getFilterBtnHref = (router, locale) => {
  const asPathParts = (router?.asPath || '').split('/') || []

  if (asPathParts.includes(translations.oglasi[locale]) || router?.asPath?.startsWith(`${translations.oglasi[locale]}`)) {
    return {
      pathname: '/mobileAdFilter',
      query: {
        category: router.query?.category
      }
    }
  }

  return {
    pathname: '/mobileAdFilter',
    query: router.query
  }
}

const getFilterBtnAs = (router, locale) => {
  const asPathParts = (router?.asPath || '').split('/') || []

  if (asPathParts.includes(translations.oglasi[locale]) || router?.asPath?.startsWith(`${translations.oglasi[locale]}`)) {
    return `/${translations.pretragaOglasa[locale]}${router.query?.category ? `/${router.query.category}` : ''}`
  }

  return `/${translations.pretragaOglasa[locale]}${router.asPath}`
}

const GroupsMenuMobile = ({
  groups,
  currentGroup,
  currentSubcategory,
  filtersCount,
  vehiclePartsGroup,
  vehiclePartsFilterValues,
  vehiclePartsCategory
}) => {
  const { t, lang } = useTranslation('common')

  const router = useRouter()

  const locale = lang?.toUpperCase() || 'ME'

  console.log('GroupsMenuMobile router.pathname', router.pathname)
  console.log('GroupsMenuMobile vehiclePartsCategory', vehiclePartsCategory)

  return (
    <React.Fragment>
      {!['/vehicleParts'].includes(router.pathname) ? <FilterButtons /> : <FilterButtonsVehicleParts filtersCount={filtersCount} />}

      <div className='kategorije'>
        <GroupHorizontalMenuMobile
          vehiclePartsGroup={vehiclePartsGroup}
          vehiclePartsFilterValues={vehiclePartsFilterValues}
          vehiclePartsCategory={vehiclePartsCategory}
        />

        {/* <SubGroupsList className='kategorije-sub' /> */}

        <div className='kategorije-pretraga'>
          {currentGroup && config.search.showTextSearchAndCategoryMenuOn.includes(currentGroup.seo) ? (
            <CategoriesFilter
              baseAs={`/${translations.pretragaOglasa[locale]}/`}
              baseHref={{ pathname: '/mobileAdFilter' }}
              baseHrefQuery={{ page: 'category-filter' }}
            />
          ) : null}
        </div>

        {router && router.asPath !== '/' && currentSubcategory ? (
          <Link href={getFilterBtnHref(router, locale)} as={getFilterBtnAs(router, locale)}>
            <a className='filter-btn'>
              {t('Filtriraj za detalje')}
            </a>
          </Link>
        ) : null}

      </div>
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    currentGroup: getCurrentGroup(state),
    currentSubcategory: getCurrentSubCategory(state)
  }
}

GroupsMenuMobile.defaultProps = {
  groups: []
}

GroupsMenuMobile.propTypes = {
  currentGroup: PropTypes.shape({
    categories: PropTypes.array,
    seo: PropTypes.string
  }),
  filtersCount: PropTypes.number.isRequired,
  isAdPage: PropTypes.bool.isRequired,
  currentSubcategory: PropTypes.object,
  router: PropTypes.shape({
    pathname: PropTypes.string
  }).isRequired,
  vehiclePartsCategory: PropTypes.string
}


export default connect(mapStateToProps)(GroupsMenuMobile)
